/**
 *
 * @param {object} form
 * @param {object} config
 * @description
 * https://www.notion.so/perfectpanel/Completed-PR-140-b2708c5e30c24f2084c7b20065743c9f
 *
 * Если Mode === 1 Показываем
 *
 * @returns {boolean}
 */
export default (form, config) => {
  const accessAutoComplete = config?.auto_complete;

  if (accessAutoComplete) {
    if (form) {
      const { mode } = form;
      if (mode === 1) {
        return true;
      }
    }
  }

  return false;
};
